export default "__VITE_ASSET__wfo9hYRE__"